import React from "react";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { FilterActionsFooter } from "@design-system/Filter/FilterActionsFooter/FilterActionsFooter";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const hasAttachmentsOption: FilterMultiselectOption = {
    value: "has_attachments",
    label: "Has attachments",
    searchableLabel: "has attachments",
};

const noAttachmentsOption: FilterMultiselectOption = {
    value: "no_attachments",
    label: "Does not have attachments",
    searchableLabel: "does not have attachments",
};

export const TaskAttachmentsFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <div className={styles.filter}>
        <TriStateBooleanFilter
            value={filters.hasAttachments}
            onChange={(hasAttachments) => onChange({ hasAttachments })}
            trueOption={hasAttachmentsOption}
            falseOption={noAttachmentsOption}
            name="hasAttachments"
        />
        {typeof filters.hasAttachments === "boolean" && (
            <FilterActionsFooter
                deselectFunction={() => onChange({ hasAttachments: undefined })}
                selectedCount={1}
            />
        )}
    </div>
);
